import { render, staticRenderFns } from "./DiffTablesDialog.vue?vue&type=template&id=6bb6236d"
import script from "./DiffTablesDialog.vue?vue&type=script&lang=js"
export * from "./DiffTablesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports